import {DiagramActionType} from '@/enums/diagrams';
import {pull} from 'lodash';
import {DiagramAction} from './diagramAction';

export class ActionManager {
  // График
  private chart: any = null;

  // Серии к которым привязываются действия
  private bindedSeriesIds: string[] = [];

  // Список текущих примененных действий
  private appliedActions: DiagramAction[] = [];

  // Словарь созданных объектов действий по их типу
  private actions = new Map<DiagramActionType, DiagramAction>();

  constructor(actions: DiagramAction[]) {
    actions.forEach(x => this.actions.set(x.type, x));
  }

  // Инициализация менеджера (передаем график и серию)
  init(chart: any, bindedSeriesIds: string[]) {
    this.chart = chart;
    this.bindedSeriesIds = bindedSeriesIds;
  }

  // Применить действие
  applyAction(actionType: DiagramActionType, actionData: any) {
    const action = this.actions.get(actionType);
    if (!action || !this.bindedSeriesIds.length) return;
    this.appliedActions.push(action);
    action.apply(this.chart, this.bindedSeriesIds, actionData);
  }

  // Отменить действие
  cancelAction(actionType: DiagramActionType) {
    const action = this.appliedActions.find(x => x.type == actionType);
    if (action) {
      pull(this.appliedActions, action);
      action.cancel();
    }
  }

  // Обновить действие
  updateAction(actionType: DiagramActionType, actionData: any) {
    const action = this.actions.get(actionType);
    if (!action || !this.bindedSeriesIds.length) return;
    action.update(actionData, this.bindedSeriesIds);
  }

  // Обновить все примененные действия
  updateAppliedActions(actionDataMap: Map<DiagramActionType, any>, bindedSeriesIds: string[]) {
    this.bindedSeriesIds = bindedSeriesIds;
    this.appliedActions.forEach(x => x.update(actionDataMap.get(x.type), this.bindedSeriesIds));
  }

  // Перерисовка примененных действий
  renderAppliedActions() {
    this.appliedActions.forEach(x => x.render());
  }

  // Получить данные примененных действий
  getAppliedActionsData() {
    const actionData = new Map();
    this.appliedActions.forEach(action => actionData.set(action.type, action.getActionData()));
    return actionData;
  }
}
